// Success Messages
export const DEFAULT_SUCCESS = 'DEFAULT_SUCCESS';
export const SUCCESS_INVITATION = 'SUCCESS_INVITATION';
export const SUCCESS_USER_REMOVED = 'SUCCESS_USER_REMOVED';
export const SUCCESS_USER_UPDATE = 'SUCCESS_USER_UPDATE';

export const SUCCESS_CREATE_SCHEDULING_INSTANCE = 'SUCCESS_CREATE_SCHEDULING_INSTANCE';
export const SUCCESS_DELETE_SCHEDULING_INSTANCE = 'SUCCESS_DELETE_SCHEDULING_INSTANCE';

// Error Messages
export const DEFAULT_ERROR = 'DEFAULT_ERROR';
export const NOT_AUTHORIZED_DEFAULT = 'NOT_AUTHORIZED_DEFAULT';

export const NOT_AUTHORIZED_USER_FETCH = 'NOT_AUTHORIZED_USER_FETCH';
export const NOT_AUTHORIZED_USER_VIEW = 'NOT_AUTHORIZED_USER_VIEW';
export const NOT_AUTHORIZED_USER_INVITE = 'NOT_AUTHORIZE_USER_INVITE';
export const ERROR_REMOVING_USER = 'ERROR_REMOVING_USER';

export const NOT_AUTHORIZED_CREATE_SCHEDULING_INSTANCE = 'NOT_AUTHORIZED_CREATE_SCHEDULING_INSTANCE';
export const ERROR_CREATING_SCHEDULING_INSTANCE = 'ERROR_CREATING_SCHEDULING_INSTANCE';
export const ERROR_DELETE_SCHEDULING_INSTANCE = 'ERROR_DELETE_SCHEDULING_INSTANCE';

export const ERROR_NAVIGATING_TO_INSTANCE = 'ERROR_NAVIGATING_TO_INSTANCE';

// Warning Messages
export const DEFAULT_WARNING = 'DEFAULT_WARNING';
